import LayoutPage from '@/components/Layout/LayoutPage';
import { useConsultingEngagementsEnabled } from '@/features/consulting-engagements/featureFlag';
import EngagementPage from '@/features/consulting-engagements/live/EngagementPage';
import NotFoundPage from '@/pages/NotFoundPage';

/**
 * The single `consulting-engagements` flag gate for the Hub route.
 *
 * It lives here rather than inside `EngagementPage` so the dark case renders
 * the standalone 404 page — `NotFoundPage` brings its own `Layout`, and nesting
 * it inside `LayoutPage` would double-wrap the chrome.
 */
export default function EngagementRoute(): JSX.Element {
  if (!useConsultingEngagementsEnabled()) return <NotFoundPage />;
  return (
    <LayoutPage showNav>
      <EngagementPage />
    </LayoutPage>
  );
}
